import React from "react";
import { colors, typography } from "../../../design-system";

interface SummaryStatProps {
  label: string;
  value: string;
  emphasis?: boolean;
}

export default function SummaryStat({ label, value, emphasis }: SummaryStatProps) {
  return (
    <div>
      <div
        style={{
          ...typography.tiny,
          color: colors.textMuted,
          textTransform: "uppercase",
          letterSpacing: "0.08em",
          marginBottom: 6,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize: emphasis ? 28 : 20,
          fontWeight: 700,
          color: emphasis ? colors.brandPrimary : colors.textPrimary,
          fontFeatureSettings: '"tnum" 1',
          letterSpacing: "-0.02em",
          lineHeight: 1.2,
        }}
      >
        {value}
      </div>
    </div>
  );
}